export const LocalStorageKeys = {
    TOKEN: 'stiftselskab_user_token',
    LANGUAGE: 'stiftselskab_language',
    DEMO_MODE: 'stiftselskab_demo_mode',
};
